import { CLEAR_APPLICATION_DATA, SAVE_NCE_INFO } from "../constant";

export const nceApplicationInitialState = (data) => {
	return {
		studentTypeId: data?.studentTypeId,
		...(data?.applicationType && {
			applicationType: {
				label: data?.applicationType,
				value: data?.applicationTypeId
			}
		}),
		passport: {
			passport: data?.passport
		},
		...(data?.sessionId && {
			sessionId: {
				value: data?.sessionId,
				label: data?.session
			}
		}),
		applicationTypeId: data?.applicationTypeId,
		regNumber: data?.regNumber,
		rrr: data?.rrr,
		basicInformation: {
			applicationNumber: data?.personalInfoResponse?.applicationNumber,
			rrr: data?.personalInfoResponse?.rrr,
			lastname: data?.personalInfoResponse?.lastname,
			firstname: data?.personalInfoResponse?.firstname,
			middlename: data?.personalInfoResponse?.middlename,
			nin: data?.personalInfoResponse?.nin,
			homeTown: data?.personalInfoResponse?.homeTown,
			...(data?.personalInfoResponse?.genderId && {
				genderId: {
					value: data?.personalInfoResponse?.genderId,
					label: data?.personalInfoResponse?.gender
				}
			}),
			dateOfBirth: data?.personalInfoResponse?.dateOfBirth,
			...(data?.personalInfoResponse?.country && {
				countryId: {
					value: data?.personalInfoResponse?.countryId,
					label: data?.personalInfoResponse?.country
				}
			}),
			...(data?.personalInfoResponse?.stateId && {
				stateId: {
					value: data?.personalInfoResponse?.stateId,
					label: data?.personalInfoResponse?.state
				}
			}),
			...(data?.personalInfoResponse?.lgaId && {
				lgaId: {
					value: data?.personalInfoResponse?.lgaId,
					label: data?.personalInfoResponse?.lga
				}
			}),
			contactAddress: data?.personalInfoResponse?.contactAddress,
			mobileNumber: data?.personalInfoResponse?.mobileNumber,
			...(data?.personalInfoResponse?.religionId && {
				religionId: {
					value: data?.personalInfoResponse?.religionId,
					label: data?.personalInfoResponse?.religion
				}
			}),
			email: data?.personalInfoResponse?.email,
			disability: data?.personalInfoResponse?.disability,
			passportAsBase64: data?.passport
		},
		programmeDetails: {
			...(data?.programmeDetailsResponse?.firstChoiceSchoolId && {
				facultyId: {
					value: data?.programmeDetailsResponse?.firstChoiceSchoolId,
					label: data?.programmeDetailsResponse?.firstChoiceSchool
				}
			}),
			...(data?.programmeDetailsResponse?.firstChoiceDepartmentId && {
				departmentId: {
					value: data?.programmeDetailsResponse
						?.firstChoiceDepartmentId,
					label: data?.programmeDetailsResponse?.firstChoiceDepartment
				}
			}),
			programmeTypesId: data?.programmeTypeId,
			...(data?.programmeDetailsResponse?.secondChoiceDepartmentId && {
				alternativeDepartmentId: {
					value: data?.programmeDetailsResponse
						?.secondChoiceDepartmentId,
					label: data?.programmeDetailsResponse
						?.secondChoiceDepartment
				}
			}),
			...(data?.programmeDetailsResponse?.secondChoiceDepartmentId && {
				alternativeFacultyId: {
					value: data?.programmeDetailsResponse?.secondChoiceSchoolId,
					label: data?.programmeDetailsResponse?.secondChoiceSchool
				}
			}),
			jambRegNumber:
				data?.programmeDetailsResponse?.jambDetails?.jambRegNumber,
			utmeScore: data?.programmeDetailsResponse?.jambDetails?.utmeScore,
			...(data?.programmeDetailsResponse?.departmentOptionId && {
				departmentOptionId: {
					value: data?.programmeDetailsResponse?.departmentOptionId,
					label: data?.programmeDetailsResponse?.departmentOption
				}
			}),
			...(data?.programmeDetailsResponse
				?.programmeInfoResponseCategoryId && {
				programmeInfoResponseCategoryId: {
					value: String(
						data?.programmeDetailsResponse
							?.programmeInfoResponseCategoryId
					),
					label: data?.programmeDetailsResponse
						?.programmeDetailsResponse
				}
			}),
			programmeCategoryId: {
				value: data?.applicationTypeId,
				label: data?.applicationType
			},

			firstSubjectId:
				data?.programmeDetailsResponse?.jambDetails?.firstSubjectId !=
				null
					? {
							value: data.programmeDetailsResponse?.jambDetails
								?.firstSubjectId,
							label: data.programmeDetailsResponse?.jambDetails
								?.firstSubject
					  }
					: null,

			secondSubjectId:
				data?.programmeDetailsResponse?.jambDetails?.secondSubjectId !=
				null
					? {
							value: data.programmeDetailsResponse?.jambDetails
								?.secondSubjectId,
							label: data.programmeDetailsResponse?.jambDetails
								?.secondSubject
					  }
					: null,

			thirdSubjectId:
				data?.programmeDetailsResponse?.jambDetails?.thirdSubjectId !=
				null
					? {
							value: data.programmeDetailsResponse?.jambDetails
								?.thirdSubjectId,
							label: data.programmeDetailsResponse?.jambDetails
								?.thirdSubject
					  }
					: null,

			fourthSubjectId:
				data?.programmeDetailsResponse?.jambDetails?.fourthSubjectId !=
				null
					? {
							value: data.programmeDetailsResponse?.jambDetails
								?.fourthSubjectId,
							label: data.programmeDetailsResponse?.jambDetails
								?.fourthSubject
					  }
					: null
		},
		nextOfKin: {
			id: data?.nextOfKin?.id,
			fullname: data?.personalInfoResponse?.nextOfKinsResponse?.fullName,
			...(data?.personalInfoResponse?.nextOfKinsResponse
				?.relationshipId && {
				relationshipId: {
					value: data?.personalInfoResponse?.nextOfKinsResponse?.relationshipId,
					label: data?.personalInfoResponse?.nextOfKinsResponse?.relationship
				}
			}),
			mobileNumber:
				data?.personalInfoResponse?.nextOfKinsResponse?.mobileNumber,
			email: data?.nextOfKin?.email,
			address: data?.personalInfoResponse?.nextOfKinsResponse?.address
		},
		educationalHistory: data?.educationalHistoryResponse?.map((item) => ({
			...item,
			institutionName: item.name ?? "",
			state: item.place ?? "",
			certificate: item.certificateType
		})),

		oLevelResponse: {
			sittings: data?.olevelResponse?.map((item) => ({
				...item,
				resultPin: item?.resultPin,
				resultPinSno: item?.resultSerialNumber,
				examNumber: item?.examNumber,
				examCentre: item?.examCenter,
				oLevelType: {
					value: item?.examinationTypeId,
					label: item?.examinationType
				},
				examYear: { value: item?.examYear, label: item?.examYear },
				subjects: [
					...Object?.keys(item?.subjectGrade).map((key, index) => ({
						subject: {
							label: key?.toUpperCase(),
							value: Object?.keys(item?.subjectGradeId)?.[index]
						},
						grade: {
							label: item?.subjectGrade?.[key],
							value: Object?.values(item?.subjectGradeId)?.[index]
						}
					}))
				]
			}))
		}
	};
};

export const nceReducer = (state = {}, action) => {
	switch (action.type) {
		case SAVE_NCE_INFO:
			return action.payload;
		case CLEAR_APPLICATION_DATA:
			return {};
		default:
			return state;
	}
};
